<template>
  <div class="pt-1">
    <v-img
      class="mb-2 hidden-md-and-down"
      width="50%"
      :src="documentURL"
    ></v-img>

    <!-- Smaller screens -->
    <v-img
      class="mb-2 hidden-lg-and-up"
      width="100%"
      :src="documentURL"
    ></v-img>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "Documents",
  data: () => ({
    documentTypes: [
      { type: "text/plain", icon: "insert_drive_file" },
      { type: "default", icon: "insert_drive_file" }
    ],
    documentType: {}
  }),
  props: ["eventDateObj"],
  methods: {
    getDocumentIcon: function(type) {
      for (let x = 0; x < this.documentTypes.length; x++) {
        if (type.includes(this.documentTypes[x].type)) {
          return this.documentTypes[x].icon
        }
      }
      // Return default icon
      return this.documentTypes[this.documentTypes.length - 1].icon
    }
  },
  computed: {
    ...mapGetters({
      getApiEndPoint: 'getApiEndPoint'
    }),
    documentURL() {
      const token = window.localStorage.getItem('session')
      const path = this.eventDateObj.params.url
      const baseURL = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${path}` : path
      return `${baseURL}?token=${token}&ignoreOnTimeline=true`
    }
  }
}
</script>
<style>
.document_attachment_icon {
  display: inline-block;
}
</style>
